import { useQuery } from 'react-query';
import { Rule } from './atom';
import { dimensionTraceId } from './constant';
import { eventNameFilter, notEqualUnknownFilter } from './useDimension';
import { getDimensionData } from '@src/api/dimensionContainer';
import instance from '@api/axiosInstance';
import { buildDimensionQuery } from '@src/components/dimension-panel-hz/hooks/utils';
import moment from 'moment';
import { get, isEmpty } from 'lodash';

export const useTraceId = (
  interval,
  metricFilter,
  filter,
  networkRequestUrl: Record<string, string>,
) => {
  const drillDownFilters: Rule[][] = [notEqualUnknownFilter(dimensionTraceId), eventNameFilter()];
  for (const [key, value] of Object.entries(networkRequestUrl)) {
    if (value) {
      drillDownFilters.push([
        {
          field: key,
          key,
          op: 'eq',
          value,
          display: value,
          originalField: key,
        },
      ]);
    }
  }
  const query: any = buildDimensionQuery({
    dimension: dimensionTraceId,
    metrics: [],
    filter,
    interval: `${moment(interval.from).format()}/${moment(interval.to).format()}`,
    sortByMetric: null,
  });
  query.limit = 10;
  query.isLiveMode = false;
  query.metricFilter = metricFilter?.[0]?.rule ? [metricFilter[0].rule] : [];
  query.type = 'multi-group-by';
  query.options['useSamplingForEventAnalysis'] = true;
  query.options['samplingAsDataset'] = true;
  query.drillDownFilters = drillDownFilters;

  const { data, isLoading, isError, refetch } = useQuery(
    [interval, metricFilter, filter, networkRequestUrl],
    () => {
      return getDimensionData({ queries: [query] }, {}, instance).then((response) => {
        const res = get(response, 'data.metadataFilterData[0].data[0].results')?.map(
          (i) => i[dimensionTraceId],
        );
        return res;
      });
    },
    {
      enabled: !isEmpty(networkRequestUrl),
      refetchOnWindowFocus: false,
      retry: false,
    },
  );

  return { data, isLoading, refetch, isError };
};
